export const calculateRemainingExercisable = (
  vestedSharesCount: number,
  exercisedCount: number,
  exerciseAmount: number,
  returnedToPool: number,
) => Math.max(vestedSharesCount - exercisedCount - exerciseAmount - returnedToPool, 0);

export const formatRemainingExercisable = (
  vestedSharesCount: number,
  exercisedCount: number,
  exerciseAmount: number,
  returnedToPool: number,
) =>
  calculateRemainingExercisable(
    vestedSharesCount,
    exercisedCount,
    exerciseAmount,
    returnedToPool,
  ).toLocaleString('en-US');
